import { render, staticRenderFns } from "./ModattaMediaLogos.vue?vue&type=template&id=093f02d2"
import script from "./ModattaMediaLogos.vue?vue&type=script&lang=js"
export * from "./ModattaMediaLogos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports